function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.13 1.93c2.35 0 4.63.66 6.6 1.92 1.08.7 2.04 1.54 2.85 2.52l1.57-1.02c.5-.33.93-.1.92.5v1.88c-.02.6-.03 1.6-.03 2.2l-.02 1.87c0 .6-.47.9-1.03.67l-1.78-.74-2.04-.87-1.75-.74c-.56-.23-.6-.7-.1-1.03l1.97-1.3a8.692 8.692 0 00-2.02-1.75c-1.53-1-3.3-1.5-5.14-1.5-5.24 0-9.5 4.2-9.5 9.4s4.26 9.4 9.5 9.4c1.95 0 3.82-.58 5.4-1.67a9.27 9.27 0 003.45-4.3c.24-.67 1.02-1 1.72-.74s1.03 1.04.76 1.73a12.273 12.273 0 01-11.38 7.65c-3.26 0-6.32-1.26-8.63-3.54S1.92 17.23 1.92 14c0-3.23 1.27-6.26 3.57-8.54s5.36-3.53 8.62-3.53zm-2.28 14.22a.944.944 0 01-.26-.64V8.9c0-.5.4-.9.9-.9h.6c.5 0 .9.4.9.9V14h3.9c.5 0 .9.4.9.9v.6c0 .5-.4.92-.9.92h-5.4c-.27 0-.5-.1-.66-.27z",
  "data-v-681e7184": "",
  className: ""
});

var SvgDuration = function SvgDuration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "duration",
    role: "img",
    viewBox: "0 0 28 28",
    className: "svg-inline--fa fa-duration fa-w-16",
    "data-v-681e7184": "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDuration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/duration.2b1c1468.svg";
export { ForwardRef as ReactComponent };